import axios from "axios";
import { API_BASE } from "./config";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
  } catch {
    // ignore
  }
  return config;
});

export default api;
